import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/helpers/base.service';
import { iReleaseNotesRequest, iReleaseNotesResponse } from 'src/app/helpers/Interfaces/release-notes';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService extends BaseService {

  private _getAll = `${environment.base_url}/api/ReleaseNotes/GetAll`;
  private _getById = `${environment.base_url}/api/ReleaseNotes/GetById`;
  private _getNotExpired = `${environment.base_url}/api/ReleaseNotes/GetNotExpired`;
  private _add = `${environment.base_url}/api/ReleaseNotes/Add`;
  private _update = `${environment.base_url}/api/ReleaseNotes/Update`;
  private _delete = `${environment.base_url}/api/ReleaseNotes/Remove`;
  private _generate = `${environment.ai_url}/release_note_creator/osquare_release_notes`;

  constructor() {
    super();
  }

  getAll(): Observable<iReleaseNotesResponse[]> {
    return this._http.get<iReleaseNotesResponse[]>(this._getAll);
  }

  getNotExpired(date: string): Observable<iReleaseNotesResponse> {
    return this._http.get<iReleaseNotesResponse>(`${this._getNotExpired}?date=${date}`);
  }

  getById(id: string): Observable<iReleaseNotesResponse> {
    return this._http.get<iReleaseNotesResponse>(`${this._getById}?id=${id}`);
  }

  add(payload: iReleaseNotesRequest): Observable<iReleaseNotesResponse> {
    return this._http.post<iReleaseNotesResponse>(this._add, payload);
  }

  update(payload: iReleaseNotesRequest): Observable<iReleaseNotesResponse> {
    return this._http.put<iReleaseNotesResponse>(this._update, payload);
  }

  delete(id: string): Observable<boolean> {
    return this._http.delete<boolean>(`${this._delete}?id=${id}`);
  }

  generate(payload: {
    project_id: string;
    start_date: string;
    end_date: string;
    company_id?: string;
    station_id?: string;
    workspace_id?: string;
  }
  ): Observable<any> {

    if (!payload.project_id || !payload.start_date || !payload.end_date) {
      throw new Error('Missing mandatory fields: project_id, start_date, and end_date are required.');
    }

    const headers = new HttpHeaders({ skipGlobalErrorToast: 'true' });

    return this._http.post(this._generate, payload, { responseType: 'json', headers });
  }
}
